var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cross") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bundle-os-x-cursors",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Made-with-\\uD83D\\uDC95by-Azendoo-design-team---@azendoo",
    transform: "translate(-302.000000, -35.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cross",
    transform: "translate(302.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,6 L8.99,6 L8.99,0 L6.01,0 L6.01,6 L0,6 L0,9 L6.01,9 L6.01,15 L8.99,15 L8.99,9 L15,9 L15,6 Z",
    id: "cursor",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9902,7.0103 L7.9902,7.0103 L7.9902,1.0003 L7.0102,1.0003 L7.0102,7.0103 L1.0102,7.0103 L1.0102,7.9903 L7.0102,7.9903 L7.0102,14.0003 L7.9902,14.0003 L7.9902,7.9903 L13.9902,7.9903 L13.9902,7.0103 Z",
    id: "cursor",
    fill: "#231F1F"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.173e98d0c7ade078ba0090d180aea4f4.svg";
export { ForwardRef as ReactComponent };